import { useState, useEffect, useCallback } from 'react';
import FinancialRecordService from '../../../../services/financial_record_service';
import { useTenant } from '../../../../hooks/useTenant';
import { FINANCIAL_STATUS, FINANCIAL_TYPES, FINANCIAL_SOURCES } from '../../../../constants/financial';

const useMemberFinancials = (member) => {
    const { idTenant } = useTenant();
    const [financials, setFinancials] = useState([]);
    const [loading, setLoading] = useState(false);

    const refresh = useCallback(async () => {
        if (!member?.id || !idTenant) return;
        setLoading(true);
        try {
            const data = await FinancialRecordService.getByMember(idTenant, member.id);
            setFinancials(data);
        } catch (error) {
            console.error("Erro ao carregar financeiro do membro:", error);
        } finally {
            setLoading(false);
        }
    }, [member?.id, idTenant]);

    useEffect(() => {
        refresh();
    }, [refresh]);

    // Saldo devedor do CLIENTE: apenas registros com sourceType "MEMBER" (dívida real do aluno).
    // Registros com sourceType "ACQUIRER" são parcelas que a adquirente deve ao negócio — não dívida do cliente.
    const pendingDebt = financials.filter(f =>
        f.type === FINANCIAL_TYPES.INCOME &&
        (f.status === FINANCIAL_STATUS.PENDING || f.status === FINANCIAL_STATUS.OVERDUE) &&
        f.sourceType === FINANCIAL_SOURCES.MEMBER
    );
    const totalDebt = pendingDebt.reduce((acc, curr) => acc + (curr.netAmount || curr.grossAmount || 0), 0);

    return {
        financials,
        loading,
        pendingDebt,
        totalDebt,
        refresh
    };
};

export default useMemberFinancials;
